import { render, staticRenderFns } from "./ApplicationAssignDropdown.vue?vue&type=template&id=e057c8f2&scoped=true&lang=pug&"
import script from "./ApplicationAssignDropdown.vue?vue&type=script&lang=js&"
export * from "./ApplicationAssignDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationAssignDropdown.vue?vue&type=style&index=0&id=e057c8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e057c8f2",
  null
  
)

/* custom blocks */
import block0 from "./ApplicationAssignDropdown.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports